import { useQuery, useLazyQuery } from "@apollo/client/react"; import React, { Fragment, useMemo, useState, useEffect } from 'react';

import { Box, Grid } from '@mui/material';
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from '../../../components/formGroupGenerator/RenderInputRowByType';
import { toast } from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetConfirmarEquipoColumns } from './columns';
import { invariantWithToast } from '../../../hooks/invariantWithToast';
import SeleccionarProfesionalContent from './SeleccionarProfesionalContent';
import { GET_ALL_FRECUENCIA_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getFrecuenciaProfesional';
import { adaptFrecuenciaProfesionalArray } from '../../../adapters/frecuenciaProfesionalAdapter';
import { adaptProfesionalesRequisitosArray, GET_PROFESIONALES_REQUISITOS } from '../../../data/graphQL/queries/ResumenIngresoValidation/getProfesionalesRequisitos';
import { TextInput } from '../../../components/textInput/TextInput';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { adaptTipoProfesionalArray } from '../../../adapters/tipoProfesionalAdapter';
import { adaptEquipoArray, GET_EQUIPO_BY_ID_EVALUACION } from "../../../data/graphQL/queries/ResumenIngresoValidation/getConfirmacionEquipoByIdEvaluacion";


export const ConfirmarEquipoInput = ({
  idEvaluacion,
  idDelegacion,
  handleClickAceptar,
  otherButtonsLoading
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [tiposProfesional, setTiposProfesional] = useState([]);
  const [frecuenciasProfesional, setFrecuenciasProfesional] = useState([]);
  const [equipo, setEquipo] = useState([]);
  const [allProfesionales, setAllProfesionales] = useState([]);
  const [proximoIntegrante, setProximoIntegrante] = useState({});
  const [seleccionarProfesional, setSeleccionarProfesional] = useState(false);
  const [confirmacionSinEquipo, setConfirmacionSinEquipo] = useState(false);

  const [getEquipo] = useLazyQuery(GET_EQUIPO_BY_ID_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idEvaluacion) return;
    getEquipo({
      variables: {
        idEvaluacion: idEvaluacion
      }
    }).then(({ data }) => { setEquipo(adaptEquipoArray(data)); }).
      catch((error) => { console.error("Error fetching equipo:", error); });

  }, [idEvaluacion]);

  const onDeleteRow = (idFigura, idFrecuencia, idProfesional) => {
    setEquipo((prevEquipo) => prevEquipo.filter((item) => item.idFiguraProfesional !== idFigura && item.idFrecuenciaProfesional !== idFrecuencia && item.idProfesional !== idProfesional));
  };

  const equipoColumns = useGetConfirmarEquipoColumns(tiposProfesional, frecuenciasProfesional, onDeleteRow);

  const handleChange = (name, value) => {
    setProximoIntegrante((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleClose = () => {
    if (seleccionarProfesional) {
      setSeleccionarProfesional(false);
    } else {
      setOpenModal(false);
      setProximoIntegrante({});
    }
  };

  const resetEquipo = () => {
    setEquipo([]);
  };

  const handleOverrideClickConfirmar = () => {
    if (!equipo.length && !confirmacionSinEquipo) {
      setConfirmacionSinEquipo(true);
    } else {
      handleClickAceptar(equipo, resetEquipo);
      handleClose();
      setConfirmacionSinEquipo(false);
    }
  };

  const handleClickAgregar = () => {
    try {
      invariantWithToast(!proximoIntegrante?.idTipoProfesional, 'Debe Elegir un Tipo Profesional.');
      invariantWithToast(!proximoIntegrante?.idFrecuencia, 'Debe Elegir una frecuencia.');

      setEquipo((prevEquipo) =>
        [...prevEquipo, { ...proximoIntegrante }]
      );
      setProximoIntegrante({});
    } catch (error) {
      console.error(error);
    }
  };

  const onSelectProfesional = (row) => {
    setSeleccionarProfesional(false);

    setProximoIntegrante((prevDatos) => ({
      ...prevDatos,
      idProfesional: row?.row?.idProfesional,
      nombreCompleto: row?.row?.nombre
    }));
  };

  const onOpenProfesionales = () => {
    if (!proximoIntegrante?.idTipoProfesional) return toast.error('Debe seleccionar un Tipo profesional.');
    setSeleccionarProfesional(true);
  };

  const newInput = useMemo(() => {
    return {
      displayName: 'Armar equipo',
      name: 'armarEquipo',
      type: 'button',
      isLoading: otherButtonsLoading,
      sx: { width: 'max-content' },
      variant: 'outlined',
      col: 30,
      onClick: () => handleOpenModal()
    };
  }, [otherButtonsLoading]);

  const profesionalesPermitidos = useMemo(() => {
    // Filtrar los profesionales que ya están en el equipo
    const profesionalesNoEnEquipo = allProfesionales?.filter(
      (prof) => !equipo.some((eq) => eq.idProfesional === prof.idProfesional)
    );

    return profesionalesNoEnEquipo?.filter(
      (prof) => prof.idTipoProfesional === proximoIntegrante.idTipoProfesional ||
        proximoIntegrante.idTipoProfesional == 7 && (prof.idTipoProfesional === 7 || prof.idTipoProfesional === 2)
    ); //si el profesional es Enfermero de guardia se le devuelven tanto enfermeros de guardia(id: 7) como enfermeros(id: 2)
  }, [
    allProfesionales,
    proximoIntegrante?.idTipoProfesional,
    equipo]
  );

  const { data: dataProfesionalesRequisitos } = useQuery(GET_PROFESIONALES_REQUISITOS, {
    variables: { idDelegacion: idDelegacion },
  });

  const { data: dataProfesionales } = useQuery(GET_ALL_TIPO_PROFESIONALES);

  const { data: dataFrecProfesionales } = useQuery(GET_ALL_FRECUENCIA_PROFESIONALES);

  useEffect(() => {
    if (!dataProfesionalesRequisitos) return;

    setAllProfesionales(adaptProfesionalesRequisitosArray(dataProfesionalesRequisitos?.profesionalesRequisitos || []));
  }, [dataProfesionalesRequisitos]);

  useEffect(() => {
    if (!dataProfesionales) return;

    setTiposProfesional(adaptTipoProfesionalArray(dataProfesionales));
  }, [dataProfesionales]);

  useEffect(() => {
    if (!dataFrecProfesionales) return;

    setFrecuenciasProfesional(adaptFrecuenciaProfesionalArray(dataFrecProfesionales).filter((x) => !!x.id));
  }, [dataFrecProfesionales]);

  const validatedInputs = useMemo(() => {
    return inputsValidar.map((input) => {
      switch (input.name) {
        case 'idTipoProfesional':
          input.options = tiposProfesional;
          break;
        case 'idFrecuencia':
          input.options = frecuenciasProfesional;
          break;
        case 'agregarProfesional':
          input.onClick = handleClickAgregar;
          break;
        default:
          break;
      }

      return input;
    });
  }, [
    tiposProfesional,
    frecuenciasProfesional,
    proximoIntegrante,
    idEvaluacion,
    equipo]
  );

  return <>
    <RenderInputsRowByType
      input={newInput}
      value={null}
      handleChange={null} />

    <CustomDialog
      maxWidth='md'
      fullWidth
      onCancel={() => handleClose()}
      {...!seleccionarProfesional && {
        onAccept: () => handleOverrideClickConfirmar(),
        acceptText: 'Confirmar'
      }}
      open={openModal && !confirmacionSinEquipo}
      cancelText={seleccionarProfesional ? 'Atras' : 'Cerrar'}
      title={seleccionarProfesional ? 'Seleccionar Profesional' : 'Armar equipo'}>

      {!seleccionarProfesional && <div>
        <Grid
          container
          columnSpacing={3}
          rowSpacing={3}
          columns={100}>

          {validatedInputs.map((input, index) => {
            return <Fragment key={`input-${input.name}-index${index}`}>
              {input.name !== 'idProfesional' && <RenderInputsRowByType
                input={input}
                value={proximoIntegrante[input.name]}
                handleChange={handleChange} />
              }
              {input.name === 'idProfesional' && <Grid size={{ xs: input.col || 25 }}>
                <TextInput
                  label={input.displayName}
                  onFocus={onOpenProfesionales}
                  placeholder={input.displayName}
                  value={proximoIntegrante?.nombreCompleto || ''}
                  searchIcon />

              </Grid>}
            </Fragment>;
          })}
        </Grid>
        <Box sx={{ marginTop: 2 }}>
          <DataGridGenerico
            rows={equipo}
            columns={equipoColumns}
            hideFooterPagination={false}
            toolbar={false} />

        </Box>
      </div>}
      {seleccionarProfesional && <SeleccionarProfesionalContent
        profesionalesPermitidos={profesionalesPermitidos}
        tiposProfesional={tiposProfesional}
        onRowClick={onSelectProfesional} />
      }
    </CustomDialog>
    <CustomDialog
      maxWidth='sm'
      fullWidth
      onCancel={() => setConfirmacionSinEquipo(false)}
      onAccept={() => handleOverrideClickConfirmar()}
      open={confirmacionSinEquipo}
      acceptText='Confirmar sin equipo'
      cancelText='Cancelar'
      title='¿Está seguro que desea confirmar sin equipo?'>
    </CustomDialog>
  </>;
};

const inputsValidar = [
  {
    displayName: 'Tipo Profesional',
    name: 'idTipoProfesional',
    type: 'select',
    options: [],
    col: 25
  },
  {
    displayName: 'Frecuencia',
    name: 'idFrecuencia',
    type: 'select',
    col: 25
  },
  {
    displayName: 'Profesional',
    name: 'idProfesional',
    type: 'search',
    col: 35
  },
  {
    displayName: 'Agregar',
    name: 'agregarProfesional',
    type: 'button',
    variant: 'outlined',
    col: 15
  }];